import React from 'react';

type InputProps = React.PropsWithoutRef<JSX.IntrinsicElements['input']> & {
    label?: string,
    type?: string
};

export const Input: React.FunctionComponent<InputProps> = ({
                                                               label,
                                                               type = 'text',
                                                               className = '',
                                                               ...rest
                                                           }) => {
    const inputClassNames = [
        'form-control',
        className,
    ]
        .filter(Boolean)
        .join(' ');

    return (
        <div className="form-group">
            {label && <label>{label}</label>}
            <input type={type || 'text'}
                   name={name}
                   className={inputClassNames}
                   {...rest}
            />
        </div>
    );
};